import { Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

export const EmployeeGrade = ({
  grades,
  gradeId,
}: {
  grades: any;
  gradeId: number;
}) => {
  const { language } = useLanguage();

  const grade = grades?.find((item: any) => item.id === gradeId);
  const gradeName = language === "en" ? grade?.gradeName : grade?.gradeNameBn;

  return <Text color="subtitle1">{gradeName}</Text>;
};
